import React, { Component, PropTypes } from 'react';

import css from './countdown.scss';

export default class Countdown extends Component {
	static propTypes = {
		timeLeft: PropTypes.number.isRequired,
		spans: PropTypes.string,
	};

	static defaultProps = {
		spans: '',
	};

	constructor(props) {
		super(props);
		this.timeInterval = false;

		this.state = {
			timeLeft: 0,
		};
	}

	componentWillMount() {
		this.state.timeLeft = this.props.timeLeft || new Date().getTime();

		this.timeInterval = setInterval(() => {
			if (this.state.timeLeft == 0) {
				this.setState({
					...this.state,
					timeLeft: this.state.timeLeft,
				});
			} else {
				this.setState({
					...this.state,
					timeLeft: this.state.timeLeft - 1,
				});
			}
		}, 1000);
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.timeLeft !== this.props.timeLeft) {
			this.setState({
				...this.state,
				timeLeft: nextProps.timeLeft || new Date().getTime(),
			});
		}
	}

	componentWillUnmount() {
		clearInterval(this.timeInterval);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextState.timeLeft !== this.state.timeLeft
		);
	}

	render() {
		let day = this.getDaysLeft(this.state.timeLeft);
		let hrs = this.getHoursLeft(this.state.timeLeft);
		let min = this.getMinutesLeft(this.state.timeLeft);
		let sec = this.getSecondsLeft(this.state.timeLeft);

		return (
			<div className={'countdown ' + this.props.spans}>
				<span className='countdown__name'>
					<span className={'countdown__name__day' + (day === 0 ? ' countdown__name__day--expendable' : '')}>
						{this.formatNumber(day, 'D')}
					</span>
					<span className={'countdown__name__hrs'}>
						{this.formatNumber(hrs, 'H')}
					</span>
					<span className='countdown__name__min'>
						{this.formatNumber(min, 'M')}
					</span>
					<span className='countdown__name__sec'>
						{this.formatNumber(sec, 'S')}
					</span>
				</span>
			</div>
		);
	}

	getDaysLeft(timeLeft) {
		let days = Math.floor(timeLeft / 86400);
		return days;
	}

	getHoursLeft(timeLeft) {
		let hoursLeft = timeLeft % 86400; // (60*60*24)
		let hours = Math.floor(hoursLeft / 3600) % 24;
		return hours;
	}

	getMinutesLeft(timeLeft) {
		let minutesLeft = (timeLeft % 86400) % 3600; // (60*60)
		let minutes = Math.floor(minutesLeft / 60) % 60;
		return minutes;
	}

	getSecondsLeft(timeLeft) {
		let secondsLeft = ((timeLeft % 86400) % 3600) % 60;
		let seconds = Math.floor(secondsLeft);
		return seconds;
	}

	formatNumber(number, letter) {
		let numberString = Math.max(number, 0).toString();
		if (numberString.length < 2) {
			numberString = '0' + numberString;
		}

		return numberString + letter + ' ';
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/countdown/countdown.js
 **/